import { ASSISTANT_ENVIRONMENT } from "@consts";

export const PREPARE_PREVIEW_DIALOG_TEXT = {
  TITLE: "Deploy a new preview version",
  DESCRIPTION: {
    [ASSISTANT_ENVIRONMENT.STAGING]: "In the Staging environment, preview versions must be deployed before they can be previewed.",
    [ASSISTANT_ENVIRONMENT.PRODUCTION]: "In the Production environment, preview versions must be deployed before they can be previewed. All external phone calls will continue to run as usual.",
  },
  INFO_MESSAGE: "The preview version stays active for 1 week. We'll notify you before it expires, and you can extend it.",
  CONFIRM_BUTTON: "Confirm",
  CANCEL_BUTTON: "Cancel"
};

